import React from 'react';
import { Row, Col, Title, QuestionNumberBadge } from '../../../../styles/common';
import { BadgetWrongRightAnswer } from './styles';
import objectiveIcon from 'img/objetive-icon.svg';
import checkIcon from 'img/check.svg';
import timesWhiteIcon from 'img/times-white.svg';
import { MESSAGES } from '../../utils/constants';

interface QuestionHeaderProps {
  questionNumber?: number;
  totalQuestions?: number;
  code?: string;
  questionAnswer?: number;
  questionAnswerCorrect?: number;
  resolved?: boolean;
}

export const QuestionHeader: React.FC<QuestionHeaderProps> = ({
  questionNumber,
  totalQuestions,
  code,
  questionAnswer,
  questionAnswerCorrect,
  resolved,
}) => {
  const isCorrect = questionAnswerCorrect === questionAnswer;
  const showBadge = questionAnswerCorrect !== undefined && !resolved;

  return (
    <Row padding="0 24px" width="100%">
      <Col width="100%">
        {code && (
          <Title>
            {questionNumber && totalQuestions && (
              <QuestionNumberBadge>
                <p>
                  {questionNumber}/{totalQuestions}
                </p>
              </QuestionNumberBadge>
            )}
            <img src={objectiveIcon} alt="" />
            <p>Questão ({code})</p>
          </Title>
        )}
      </Col>
      <Col alignItems="flex-end" height="28px">
        {showBadge && (
          <BadgetWrongRightAnswer className={isCorrect ? 'is-correct' : 'is-incorrect'}>
            {isCorrect ? (
              <img src={checkIcon} alt="" width={16} height={16} />
            ) : (
              <img src={timesWhiteIcon} alt="" width={16} height={16} />
            )}
            <p>{isCorrect ? MESSAGES.YOU_GOT_IT_RIGHT : MESSAGES.YOU_GOT_IT_WRONG}</p>
          </BadgetWrongRightAnswer>
        )}
      </Col>
    </Row>
  );
};
